
import { defineComponent, inject, ref, onMounted, onUnmounted } from "vue";
import { mapState, mapActions } from "pinia";

import { useCart } from "@/store/useCart";

export default defineComponent({
  props: {
    url: {
      type: String,
      required: true
    },
    fetchcart: {
      type: Boolean,
      required: true
    }
  },

  setup(props) {
    const isMiniCartOpen = ref(false);

    const handleClassChanges = (mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const miniCartDetails = document.getElementById('miniCartWrap');
          if (miniCartDetails && miniCartDetails.classList.contains('toggle')) {
            isMiniCartOpen.value = true;
          }
        }
      });
    };

    const toggleMiniCart = () => {
      isMiniCartOpen.value = !isMiniCartOpen.value;
    };

    const closeMiniCart = () => {
      isMiniCartOpen.value = false;
    };

    const handleClickOutside = (event) => {
      const miniCart = document.getElementById('miniCartContainer');
      if (!miniCart?.contains(event.target)) {
        isMiniCartOpen.value = false;
      }
    };

    onMounted(() => {
      const miniCartDetails = document.getElementById('miniCartWrap');
      if (miniCartDetails) {
        const observer = new MutationObserver(handleClassChanges);
        observer.observe(miniCartDetails, { attributes: true });
      }
      document.addEventListener('click', handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return {
      isMiniCartOpen,
      toggleMiniCart,
      closeMiniCart,
      handleClickOutside
    };
  },

  data() {
    return {
      showPricesAsB2b: false, hidePrices: false
    }
  },

  computed: {
    hasItems() {
      return this.numberOfItems > 0;
    },
    ...mapState(useCart, ["numberOfItems", "items", "summary"]),
    standardItems() {
      return this.items.filter((item) => item.productType === "Standard");
    },
    numberOfStandardItems() {
      return this.standardItems.length;
    },
  },
  methods: {
    async onRemove(partNo) {
      await this.removeFromCart(partNo);
    },
    ...mapActions(useCart, ["load", "import", "removeFromCart"]),
  },
  mounted() {
    if (this.$props.fetchcart) {
      this.load(false, true);
    }
    this.showPricesAsB2b = inject<boolean>("show-prices-as-b2b", false);
    this.hidePrices = inject<boolean>("hide-prices", false);
  },
});
